// MARK://dhk8/pos/pages/ShiftSelectPage
// Apertura de caja antes de operar el POS. Si la caja ya está abierta (hay un corte
// OPEN sin cierre posterior), auto-redirige a /floor. Embebe CashoutPage para abrirla.

import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { useCashcutStore } from '../stores/cashcut-store.js'
import CashoutPage from './CashoutPage.js'

export default function ShiftSelectPage() {
  const navigate = useNavigate()
  const shiftOpen = useCashcutStore((s) => s.shiftOpen)
  // NOTA: fetchCuts + el loading-gate los maneja el <CashoutPage/> embebido. Duplicarlos aquí
  // remontaba CashoutPage en bucle (cada fetchCuts toggle de loading lo desmontaba) → hang.
  const loading = useCashcutStore((s) => s.loading)

  useEffect(() => {
    if (!loading && shiftOpen) navigate('/floor', { replace: true })
  }, [shiftOpen, loading, navigate])

  return (
    <div className="dhk8-shift-root">
      <div className="dhk8-shift-header">
        <h1>Apertura de turno</h1>
        <p>Declara el fondo inicial para abrir caja antes de operar el POS.</p>
      </div>
      <CashoutPage />
      <style>{`
        .dhk8-shift-loading { display:flex; align-items:center; justify-content:center; height:60vh; font-size:var(--pos-text-md); color:var(--pos-fg-tertiary); }
        .dhk8-shift-root { display:flex; flex-direction:column; gap:var(--pos-space-4); }
        .dhk8-shift-header h1 { font-family:var(--font-display, system-ui); font-size:var(--pos-text-2xl); font-weight:var(--pos-weight-semibold); margin:0; color:var(--pos-fg); }
        .dhk8-shift-header p { font-size:var(--pos-text-sm); color:var(--pos-fg-tertiary); margin:var(--pos-space-1) 0 0; }
      `}</style>
    </div>
  )
}
